import { IconButton } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import "./BB8Link.scss";

function getIconByType(type: "arrow" | "edit") {
  switch (type) {
    case "edit": {
      return require("../assets/images/bb8-edit-24px.svg");
    }
    default:
      return require("../assets/images/bb8-keyboard_arrow_right-24px.svg");
  }
}

const BB8Link = ({
  href,
  type = "arrow",
  onClick
}: {
  href?: string | object;
  type?: "arrow" | "edit",
  onClick?: () => void;
}) => {
  if (href) {
    return (
      <Link to={href}>
        <img
          className="bb8-link"
          src={getIconByType(type)}
        />
      </Link>
    );
  }
  return (
    <IconButton onClick={onClick}>
      <img
        src={getIconByType(type)}
      />
    </IconButton>
  );
};

export default BB8Link;
